import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { UserRoundCog } from 'lucide-react';
import { Button } from '@/lib/shadcn/components/ui/button';
import { BexioContactMigrationDialog } from './BexioContactMigrationDialog';

/** Opens the Bexio company → person contact migration. Only render for super admins. */
export const BexioContactMigrationButton: React.FC = () => {
  const { t } = useTranslation('customers');
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button
        type="button"
        variant="outline"
        onClick={() => setOpen(true)}
        data-testid="bexio-migration-open"
      >
        <UserRoundCog className="mr-2 h-4 w-4" />
        {t('bexioMigration.openButton')}
      </Button>
      <BexioContactMigrationDialog open={open} onOpenChange={setOpen} />
    </>
  );
};

export default BexioContactMigrationButton;
